import _ from 'lodash';
import React, { useState } from 'react';
import {
  Border,
  Box,
  Button,
  DropDown,
  Grid,
  Margin,
  Padding,
  Queue,
  Stack,
  Text,
} from '../../components';
import { Navigation } from './shared';
import { GreenHouseAPI } from './api';
import { track } from '../../analytics/utils';

const PositionDetails = (props) => {
  let { openJob } = props;
  let { departments, location, title, absolute_url } = openJob || {
    absolute_url: '',
    departments: '',
    location: '',
    title: '',
  };
  const handleOnClick = () => {
    track('Apply Link Clicked', {
      job_title: title,
      department_name: departments[0]?.name,
      greenhouse_job_id: parseInt(absolute_url.split('=')[1]),
    });
    window.open(`${absolute_url}`, '_blank');
  };
  return (
    <Border borderSize={[0, 0, 1, 0]} borderRole="grey3">
      <Padding size={[5, 0, 3, 0]}>
        <Grid columns={2}>
          <Text align="left">
            {departments[0]?.name || 'No Type is given.'}
          </Text>

          <Text align="left">Location</Text>
        </Grid>
        <Margin size={[2, 0, 0, 0]} />
        <Grid columns={2}>
          <Text textType="primary5" align="left">
            {title || 'Job Title Not Defined'}
          </Text>
          <Text textType="primary5" align="left" vertical="top">
            {location?.name || 'location not defined'}
          </Text>
        </Grid>
      </Padding>
      <Button
        borderSize={[1]}
        radius="small"
        borderRole="grey"
        backgroundRole="white"
        width="100%"
        onClick={handleOnClick}
      >
        Learn More
      </Button>
      <Margin size={[0, 0, 5, 0]} />
    </Border>
  );
};

export const OpenRolesMobile = () => {
  let { fetchedData } = GreenHouseAPI();
  let { jobs: openJobs } = fetchedData || { jobs: '' };
  let locations = _.flow(
    (openJobs) => _.map(openJobs, 'location'),
    (openJobs) => _.map(openJobs, 'name'),
    (openJobs) => _.uniq(openJobs)
  )(openJobs);
  let teams = _.flow(
    (openJobs) => _.map(openJobs, 'departments'),
    (openJobs) => _.map(openJobs, 0),
    (openJobs) => _.map(openJobs, 'name'),
    (openJobs) => _.uniq(openJobs)
  )(openJobs);
  const [location, setLocation] = useState();
  const [team, setTeam] = useState();
  return (
    <>
      <Box ratio={0.8} backgroundImage="images/open-roles-picture.jpg" />
      <Padding size={[3, 4]}>
        <Stack size={3}>
          <Padding size={[6, 0]}>
            <Text textType="heading3">Now hiring at Glossier</Text>
          </Padding>
          <Text textType="primary4">
            Our mission is to give voice through beauty, and our team is proud
            to work at Glossier to help democratize an industry that has forever
            been top-down. Explore career & job opportunities at Glossier.
          </Text>
        </Stack>
      </Padding>

      <Padding size={[5, 4]}>
        <Stack size={3}>
          <Queue size={4}>
            <DropDown
              option={location}
              setOption={setLocation}
              dropOptions={locations}
              description="Filter by location"
            />
            <DropDown
              option={team}
              setOption={setTeam}
              dropOptions={teams}
              description="Filter by team"
            />
          </Queue>
          <Border borderSize={[0, 0, 1, 0]} borderRole="grey3" />
        </Stack>

        <Navigation>
          {_.flow(
            (openJobs) =>
              _.filter(
                openJobs,
                location
                  ? {
                      location: {
                        name: location,
                      },
                    }
                  : {}
              ),
            (openJobs) =>
              _.filter(
                openJobs,
                team
                  ? {
                      departments: [{ name: team }],
                    }
                  : {}
              ),
            (openJobs) =>
              _.map(openJobs, (openJob, index) => {
                return <PositionDetails openJob={openJob} key={index} />;
              })
          )(openJobs)}
        </Navigation>
      </Padding>
    </>
  );
};
